import { render, staticRenderFns } from "./thirdmessage.vue?vue&type=template&id=ada7e7da&scoped=true"
import script from "./thirdmessage.vue?vue&type=script&lang=js"
export * from "./thirdmessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ada7e7da",
  null
  
)

export default component.exports